import { JSX } from "react";
import { ALLOWED_COUNTRIES } from "../pages/auth/data";

// Custom Phone Input Component
export const CustomPhoneInput: React.FC<CustomPhoneInputProps> = ({ 
  value, 
  onChange, 
  countryCode, 
  error 
}) => {
  const country = ALLOWED_COUNTRIES[countryCode];

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let inputValue = e.target.value.replace(/\D/g, "");
    if (inputValue.length > country.localLength) {
      inputValue = inputValue.slice(0, country.localLength);
    }
    onChange(inputValue);
  };

  const getDisplayValue = (): string => {
    if (!value) return "";
    if (countryCode === "ng") {
      const matches = value.match(/^(\d{0,3})(\d{0,3})(\d{0,4})/);
      if (matches) return [matches[1], matches[2], matches[3]].filter(Boolean).join(" ");
    } else if (countryCode === "in") {
      const matches = value.match(/^(\d{0,5})(\d{0,5})/);
      if (matches) return [matches[1], matches[2]].filter(Boolean).join(" ");
    }
    return value;
  };

  const flagUrl = `https://flagcdn.com/24x18/${countryCode}.png`;

  return (
    <div className="relative">
      <div
        className={`flex items-center border rounded-lg overflow-hidden  h-[45px] focus-within:ring-2 focus-within:ring-[#4F46E5] focus-within:border-transparent ${
          error ? "border-red-500" : "border-gray-300"
        }`}
      >
        {/* Static dial code prefix — not editable */}
        <div className="flex items-center gap-2 bg-gray-50 border-r border-gray-300 px-3 py-2 shrink-0">
          <img
            src={flagUrl}
            alt={country.name}
            width={24}
            height={18}
            className="rounded-sm object-cover"
          />
          <span className="text-gray-600 font-medium text-sm">{country.dialCode}</span>
        </div>

        {/* Local number input only */}
        <input
          type="tel"
          value={getDisplayValue()}
          onChange={handleInputChange}
          placeholder={country.example}
          className="flex-1 px-3 py-2 bg-white outline-none text-sm"
          maxLength={countryCode === "ng" ? 12 : 11}
        />
      </div>


    </div>
  );
};

// Country options for react-select - REMOVED FLAGS, only text now
export const countryOptions: CountryOption[] = [
  {
    value: "ng",
    label: <span>Nigeria</span>,
    data: ALLOWED_COUNTRIES.ng,
  },
  {
    value: "in",
    label: <span>India</span>,
    data: ALLOWED_COUNTRIES.in,
  },
];

export interface CountryOption {
  value: 'ng' | 'in';
  label: JSX.Element;
  data: CountryInfo;
}

// Define allowed countries with their validation rules
export interface CountryInfo {
  name: string;
  code: string;
  dialCode: string;
  localLength: number;
  pattern: RegExp;
  format: string;
  example: string;
  flag: string;
}

export interface AllowedCountries {
  ng: CountryInfo;
  in: CountryInfo;
}

export interface FormData {
  org_name: string;
  country_code: 'ng' | 'in';
  domain_name: string;
  phone_number: string;
}

// Custom Phone Input Component Props
interface CustomPhoneInputProps {
  value: string;
  onChange: (value: string) => void;
  countryCode: 'ng' | 'in';
  error?: any;
}